// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7424":"d19e5e4a","8345":"55b0c500"}[chunkId] + ".chunk.css";
};